import React from "react";
import { t } from "i18next";

import { IConfig, IRedundancy } from "../../../interfaces/event/config";

import BaseToggle from "../../shared/BaseToggle";
import PageTitle from "../../shared/pageTitle/PageTitle";
import Typography from "../../shared/typography/Typography";
import { YoutubeFilled } from "../../shared/Icons/YoutubeFilled";
import { TwitchFilled } from "../../shared/Icons/TwitchFilled";
import { VimeoFilled } from "../../shared/Icons/VimeoFilled";
import Input from "../../shared/input/Input";

import { SelectButton } from "../../shared-v2/SelectButton";
import { Label } from "../../shared-v2/Label";

import { InputGroup, Row, ToggleContainer, PlayersContainer } from "./style";

interface IProps {
  config: IConfig;
  setConfig: React.Dispatch<React.SetStateAction<IConfig>>;
}

export const Redundancy = ({config, setConfig}: IProps) => {

  const updateRedundancy = (attr: keyof IRedundancy, value: boolean | string) => {
    setConfig(prev => ({...prev, redundancy: {
      ...prev.redundancy, [attr]: value
    }}));
  }

  return(
    <>
      <Row>
        <ToggleContainer>
          <PageTitle style={{margin: 0}}>{t("redundancy")}</PageTitle> 
          <BaseToggle
            tooltip={t("dashboard.event.redundancy.tooltip")!}
            initialCheck={config.redundancy.is_active ?? false} 
            onChange={(checked: boolean) => updateRedundancy("is_active", checked)} 
          />
        </ToggleContainer>
      </Row>

      <Typography type="paragraphS">{t("dashboard.event.redundancy.label")}</Typography>
      <Row>
        <PlayersContainer>
          <SelectButton onClick={() => updateRedundancy("player", "youtube")} selected={config.redundancy.player === 'youtube'} >
            <YoutubeFilled />
          </SelectButton >
          <SelectButton  onClick={() => updateRedundancy("player", "twitch")} selected={config.redundancy.player === 'twitch'}>
            <TwitchFilled />
          </SelectButton>
          <SelectButton  onClick={() => updateRedundancy("player", "vimeo")} selected={config.redundancy.player === 'vimeo'}>
            <VimeoFilled />
          </SelectButton>
        </PlayersContainer>
        <InputGroup>
          <Label>Link</Label>
          <Input 
            placeholder={t("dashboard.event.redundancy.placeholder")!}
            value={config.redundancy.link ?? ""} 
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateRedundancy("link", e.target.value)}
          />
        </InputGroup>
      </Row>
    </>
  )
}